<template>
  <div class="container" style="padding:5px 10%">
    <div class="container">
      <div class="row lt-center" style="padding-top:10px">
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4" :class="logo.css">
          <a href="/">
            <img src="/images/logo2.png" :width="logo.width" style="border-radius:5px" />
          </a>
        </div>
        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8">
          <div :class="title.css" v-bind:style="{fontSize: title.cht.ftsize, padding: '10px 0 0 10px'}" v-text="title.cht.label"></div>
          <div :class="title.css" v-bind:style="{fontSize: title.eng.ftsize, padding: '0 0 0 20px'}" v-text="title.eng.label"></div>
        </div>
      </div>
      <div class="row" style="padding-top:20px">
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3" style="padding-top:60px">
          <div style="margin-bottom:20px">
            <!-- <span class="lt-color-link lt-pointer lt-hover" v-on:click="switchLoginMode()" style="display:none">( {{loginModeStr[loginMode]}} )</span> -->
            <el-switch style="display:xblock;padding-bottom:20px" v-model="loginMode" active-color="#dd4c3b" inactive-color="#04745a"
                       active-text="家長或學生登入"
                       inactive-text="教職員登入" >
            </el-switch>
          </div>
          <div class="login-panel panel panel-primary" :style="student.css1">
            <div class="panel-heading2" :style="student.css2">
              <h3 class="panel-title" v-text="label[0]"></h3>
            </div>
            <div class="panel-body">
              <form role="form" id="form2" class="form-horizontal" action="/login" method="post" data-toggle="validator">
                <fieldset>
                  <div class="form-group row" style="margin:0 auto;width:95%;">
                    <label v-text="label[1]"></label>
                    <input class="form-control" name="login" type="text" ref="login" :placeholder="placeholder[0]" required="required" :style="student.css1">
                    <div class="help-block with-errors"></div>
                  </div>
                  <div class="form-group row" style="margin:0 auto;width:95%">
                    <label v-text="label[2]"></label>
                    <input class="form-control" name="password" type="password" value="" v-on:keyup.13="onSubmin()" :placeholder="placeholder[1]" required="required" :title="msgParam.pwdHint" :style="student.css1">
                    <div class="help-block with-errors"></div>
                  </div>
                  <div class="checkbox"></div>
                  <!-- Change this to a button or input when using this as a form -->
                  <button type="button" class="btn btn-lg btn-primary btn-block" v-on:click="onSubmin()" :style="student.css3">
                    <i class="fa fa-sign-in fa-fw"></i> {{ label[3] }}
                  </button>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-9 col-sm-8 lt-left">
          <div class="guest-box" v-for="item in listMenu" v-bind:key="item.id" v-bind:style="{backgroundColor:item.bgColor[0]}">
            <span v-on:click="guestLoginPost(item.id)">
              <i class="guest-box-icon" :class="item.icon" v-bind:style="{backgroundColor:item.bgColor[1]}"></i>
              <span :class="listMenuTextCss" style="display:inline-block;" v-text="item.label"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data: function() {
    return {
      loginMode: -1,
      loginModeStr: ["家長或學生登入", "教職員登入"],
      logo: {
        css: "lt-right",
        width: "100"
      },
      title: {
        css: "lt-left",
        cht: {ftsize: "45pt", label: "宜蘭縣政府教育處"},
        eng: {ftsize: "14pt", label: "Yilan County Government Education Department."}
      },
      label: ["請輸入帳號密碼", "登入帳號 :", "密碼 :", "登 入"],
      placeholder: ["請輸入帳號", "請輸入密碼"],
      msgParam: {title: "登入失敗!", label: "請確認帳號和密碼", pwdHint: ""},
      listMenu: [
        {id: 0, bgColor: ["#DD4C3B", "#B0452D"], icon: "fa fa-bar-chart", label: "各學校數據概況"},
        {id: 1, bgColor: ["#00BFEE", "#0B99BD"], icon: "fa fa-venus-mars", label: "學生概況"},
        {id: 2, bgColor: ["#04A65A", "#0A8447"], icon: "fa fa-book", label: "圖書借閱資訊"},
        {id: 3, bgColor: ["#F29C13", "#C27D15"], icon: "glyphicon glyphicon-indent-left", label: "資訊能力檢定與數位學習平台使用量"},
        {id: 4, bgColor: ["#DD4C3B", "#B0452D"], icon: "fa fa-television", label: "設備使用概況"},
        {id: 5, bgColor: ["#00BFEE", "#0B99BD"], icon: "fa fa-tachometer", label: "大數據議題分析"}
      ],
      listMenuTextCss: {"guest-box-text": true, "guest-box-text2": false},
      student: {
        css1: {border: "1px solid #ec823a"},
        css2: {"background-color": "#ec823a"},
        css3: {border: "1px solid #ec823a", "background-color": "#ec823a"}
      }
    };
  },
  components: {
    //
  },
  created: function() {
    //this.$serve.colorOption = "gray";
    this.$serve.colorOption = "white";
    const md= this.$js.getUrlParameter("m");
    if (md != undefined && md.length > 0) {
      this.switchLoginMode(parseInt(md));
    } else {
      this.switchLoginMode(0);
    }
  },
  mounted: function() {
    //$("body").css({"background-color":"#f2f2f2","font-family":""});
    this.$refs.login.focus();
    this.rwdParse();
    window.addEventListener("resize", this.rwdParse);
  },
  computed: {
    //
  },
  watch: {
    loginMode: function(val) {
      //console.log("loginMode=", this.loginMode);
      if (this.loginMode == true) {
      //if (val == 1) {  
        this.label = ["學生、家長模式", "學生身分證:", "學生生日:", "登 入"];
        this.placeholder = ["請輸入學生身分證", "若102/03/25則輸入1020325"];
        this.msgParam = {title: "登入失敗!", label: "請確認學生身分證和生日"};
        this.msgParam.pwdHint = "例:102/03/25則輸入1020325";
        this.student = {
          css1: {border: "1px solid #ec823a"},
          css2: {"background-color": "#ec823a"},
          css3: {border: "1px solid #ec823a", "background-color": "#ec823a"}
        };
      } else {
        this.label = ["請輸入帳號密碼", "登入帳號 :", "密碼 :", "登 入"];
        this.placeholder = ["請輸入帳號", "請輸入密碼"];
        this.msgParam = {title: "登入失敗!", label: "請確認帳號和密碼"};
        this.msgParam.pwdHint = "";
        this.student = {
          css1: {border: "1px solid #337ab7"},
          css2: {},
          css3: {}
        };
      }
    }
  },
  methods: {
    switchLoginMode: function(md) {
      console.log("md=", md);
      if (md == 1) {
        setTimeout(() => {
          this.loginMode = true;
        }, 100);
      } else {
        setTimeout(() => {
          this.loginMode = false;
        }, 100);
      }
    },
    rwdParse: function(e) {
      if (this.$js.isMobileUpright()) {
        this.title.cht.ftsize = "20pt";
        this.title.eng.ftsize = "10pt";
        this.logo = {css: "lt-center", width: "60"};
        this.title.css = "lt-center";
        this.listMenuTextCss = {"guest-box-text": false, "guest-box-text2": true};
        this.listMenu[2].label = "資訊能力檢定與…";
      } else if (this.$js.isMobile()) {
        this.title.cht.ftsize = "34pt";
        this.title.eng.ftsize = "12pt";
        this.logo = {css: "lt-center", width: "80"};
        this.title.css = "lt-center";
        this.listMenuTextCss = {"guest-box-text": false, "guest-box-text2": true};
        this.listMenu[2].label = "資訊能力檢定與數位學習平台使用量";
      } else {
        this.title.cht.ftsize = "45pt";
        this.title.eng.ftsize = "14pt";
        this.logo = {css: "lt-right", width: "100"};
        this.title.css = "lt-left";
        this.listMenuTextCss = {"guest-box-text": true, "guest-box-text2": false};
        this.listMenu[2].label = "資訊能力檢定與數位學習平台使用量";
      }
    },
    messageBox: function(msg) {
      const h = this.$createElement;
      this.$notify({
        title: this.msgParam.title,
        message: h("i", {style: "color: teal"}, msg),
        position: "top-right",
        offset: 37
      });
    },
    onSubmin: function() {
      this.$js.formID = "form2"; // form 上要設 id=, 此參數要有#
      const uid = this.$js.getFormValue("login");
      const pwd = this.$js.getFormValue("password");
      this.loginPost(uid, pwd);
    },
    loginPost: function(uid, pwd) {
      if (this.loginMode !== true) { //教職員模式
        const params = {
          url: this.$serve.baseUrl + "/userlogin",
          params: {uid: uid, pwd: pwd},
          method: "POST"
        };
        // console.log("params=", params);
        this.$js.ajaxPromise(params).then((result) => {
          // console.log("result=", result);
          if (result.jjwt.status === 0) {
            this.$serve.saveToken(result.jjwt.token);
            // this.$js.setCookie(this.$serve.sessionId, result.session, 0);
            localStorage.setItem("il-dataupdatetime", JSON.stringify(result.dataUpdate));
            sessionStorage.removeItem("il-filterparams");
            sessionStorage.removeItem("current-page");
            this.onClickMenu(0);
          } else {
            this.messageBox(this.msgParam.label);
          }
        });
      } else {
        // 116698, G222553250,0960623, 2007-06-23
        // 116700, G222553492,0960823, 2007-08-23
        // 116722, G122636243,0960825, 2007-08-25
        const params = {
          url: this.$serve.baseUrl + "/stulogin",
          params: {uid: uid, pwd: pwd},
          method: "POST"
        };
        this.$js.ajaxPromise(params).then((result) => {
          if (result.jjwt.status === 0) {
            this.$serve.saveToken(result.jjwt.token);
            // this.$js.setCookie(this.$serve.sessionId, result.session, 0);
            localStorage.setItem("il-dataupdatetime", JSON.stringify(result.dataUpdate));
            sessionStorage.removeItem("il-filterparams");
            sessionStorage.removeItem("current-page");
            this.onClickMenu(1);
          } else {
            this.messageBox(this.msgParam.label);
          }
        });
      }
    },
    guestLoginPost: function(sn) {
      var params = {
        url: this.$serve.baseUrl + "/guestlogin",
        params: {},
        method: "POST"
      };
      this.$js.ajaxPromise(params).then((result) => {
        if (result.jjwt.status === 0) {
          this.$serve.saveToken(result.jjwt.token);
          // this.$js.setCookie(this.$serve.sessionId, result.session, 0);
          localStorage.setItem("il-dataupdatetime", JSON.stringify(result.dataUpdate));
          sessionStorage.removeItem("il-filterparams");
          sessionStorage.removeItem("current-page");
          this.onClickMenu(sn);
        } else {
          this.messageBox(result.jjwt.message);
        }
      });
    },
    onClickMenu: function(sn) {
      console.log("click=", sn);
      var redirectNO = sn;
      if (redirectNO == 0) {
        this.$router.push({name: "home"});
      } else if (redirectNO == 1) {
        //location.href = "/webstu.html";
        this.$router.push({name: "webstu"});
      } else if (redirectNO == 2) {
        //location.href = "/books.html";
        this.$router.push({name: "books"});
      } else if (redirectNO == 3) {
        //location.href = "/junyi.html";
        this.$router.push({name: "junyimain"});
      } else if (redirectNO == 4) {
        //location.href = "/chrome.html";
        this.$router.push({name: "chromemain"});
      } else if (redirectNO == 5) {
        //location.href = "/agendamenu.html";
        this.$router.push({name: "agendamenu", params: {id: 0}});
      }
    }
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.rwdParse);
  }
};
</script>

<style>
.el-switch__label>span {
  font-family: Arial, "Microsoft JhengHei", 微軟正黑體, "Noto Sans TC", Fantasy, "Helvetica Neue", Helvetica, Tahoma, sans-serif;
  font-size: 16px;
  font-weight: bold;
}
</style>

<style scoped>
.container {
  margin-top: 0;
  background-color: #f2f2f2;
  font-family: Arial, "Microsoft JhengHei", 微軟正黑體, "Noto Sans TC", Fantasy, "Helvetica Neue", Helvetica, Tahoma, sans-serif;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
}

.panel-heading2 {
  height: 38px;
  color: #eee;
  background-color: #337ab7;
  padding-top: 10px;
}

.guest-box-icon {
  color: #fff;
  font-size: 32pt;
  width: 90px;
  height: 90px;
  padding: 25px 15px 23px 23px;
  /* --border: 1px solid #00f; */
  cursor: pointer;
}
.guest-box-text {
  color: #fff;
  font-size: 20pt;
  padding: 0 0 0 20px;
}

.guest-box-text2 {
  color: #fff;
  font-size: 12pt;
  padding: 0 0 0 10px;
}

.guest-box {
  color: #fff;
  font-size: 16px;
  margin-bottom: 5px;
  cursor: pointer;
}

label {
  color: #333;
}

.lt-hover:hover {
  color: #ec823a;
}
</style>
